import { uuidv7 } from 'uuidv7';

const TRACE_ID_KEY = 'dwellbot_trace_id';
let cachedTraceId: string | null = null;

export const getTraceId = (): string => {
  if (cachedTraceId) {
    return cachedTraceId;
  }
  if (typeof sessionStorage !== 'undefined') {
    const existing = sessionStorage.getItem(TRACE_ID_KEY);
    if (existing) {
      cachedTraceId = existing;
      return existing;
    }
    const created = uuidv7();
    sessionStorage.setItem(TRACE_ID_KEY, created);
    cachedTraceId = created;
    return created;
  }
  cachedTraceId = uuidv7();
  return cachedTraceId;
};

export const getEnv = () => process.env.NODE_ENV || 'local';
